var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home",
    clipPath: "url(#clip0_1503_5940)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.3185 14.9153V10.7123H10.6809V14.9153C10.6809 15.3776 11.0591 15.7559 11.5214 15.7559H14.0432C14.5055 15.7559 14.8838 15.3776 14.8838 14.9153V9.03115H16.3128C16.6995 9.03115 16.8844 8.55202 16.5902 8.29984L9.56287 1.97021C9.24344 1.68441 8.7559 1.68441 8.43648 1.97021L1.40916 8.29984C1.12336 8.55202 1.29988 9.03115 1.68655 9.03115H3.11556V14.9153C3.11556 15.3776 3.49382 15.7559 3.95614 15.7559H6.47791C6.94023 15.7559 7.3185 15.3776 7.3185 14.9153Z",
    fill: "#4C6AF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1503_5940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBlue);
export default __webpack_public_path__ + "static/media/home_blue.48faab4906564cda277eff9c352d0609.svg";
export { ForwardRef as ReactComponent };